import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber programar?',
    a: 'No. n8n es visual. Si sabes usar un diagrama de flujo, puedes dominar este sistema.'
  }, {
    q: '¿Sirve para principiantes?',
    a: 'Totalmente. Empezamos desde la instalación básica en el Tomo 1.'
  }, {
    q: '¿Qué recibo al comprar?',
    a: 'Acceso inmediato a los 4 Tomos educativos y la carpeta de archivos JSON para importar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gray-50 px-4" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-58">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-59">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm transition-all duration-200" data-id="element-60">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-61">
                <span className="font-bold text-lg text-gray-900" data-id="element-62">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-63" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-64">
                <p className="text-gray-600 text-lg" data-id="element-65">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}